export function formatNumber(amount: unknown, defaultValue = '0'): string {
  if (typeof amount !== 'number' && typeof amount !== 'string') {
    return defaultValue;
  }

  let validAmount: number;

  if (typeof amount === 'number') {
    validAmount = amount;
  } else {
    validAmount = parseInt(amount);
  }

  if (isNaN(validAmount)) return defaultValue;

  return validAmount.toLocaleString(['ban', 'id']);
}
